export const startingAtPrice = '$199/mo';

export const defaultDescription =
  'Flexcar is the easy alternative to buying or leasing. One monthly rate covers insurance, maintenance, roadside assistance, and more. No down payments, no contracts—just the freedom to drive and swap when you want.';
